import { render, staticRenderFns } from "./LagerwerteTabelle.vue?vue&type=template&id=8bc6e33e&scoped=true&"
import script from "./LagerwerteTabelle.vue?vue&type=script&lang=js&"
export * from "./LagerwerteTabelle.vue?vue&type=script&lang=js&"
import style0 from "./LagerwerteTabelle.vue?vue&type=style&index=0&id=8bc6e33e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc6e33e",
  null
  
)

export default component.exports